import { useSuspenseQuery } from '@tanstack/react-query';
import { formatEatDate, formatEatTime } from '@wodi/domain';
import { Button } from '@wodi/ui';
import { useState } from 'react';

import { can, sessionQuery } from '../api/session.ts';
import { useOnline } from '../hooks/use-online.ts';
import { toasts } from '../toasts.ts';
import { BookingDialog } from './booking-dialog.tsx';

/**
 * "Book follow-up" in the consultation workspace (appointments plan §1.1 item 7): books a
 * follow-up from this visit, offering the clinician's own schedule first.
 */
export function FollowUpButton({ visitId, patientId }: { visitId: string; patientId: string }) {
  const { data: session } = useSuspenseQuery(sessionQuery);
  const online = useOnline();
  const [open, setOpen] = useState(false);
  if (session === null || !can(session, 'appointments.book')) return null;
  return (
    <>
      <Button
        isDisabled={!online}
        onPress={() => {
          setOpen(true);
        }}
      >
        Book follow-up
      </Button>
      {open ? (
        <BookingDialog
          mode={{
            kind: 'book',
            patient: { id: patientId, displayName: 'The patient in the banner' },
            followUp: { sourceVisitId: visitId, practitionerUserId: session.user.id },
          }}
          isOpen
          onOpenChange={setOpen}
          onDone={(a) => {
            toasts.show({
              title: 'Appointment booked',
              description: `Follow-up on ${formatEatDate(new Date(a.startsAt))} at ${formatEatTime(new Date(a.startsAt))}.`,
            });
            setOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
